// @ts-nocheck
export const formatDateTime = (value, options) => {
  if (!value) {
    return "-";
  }

  const dateOnlyMatch = typeof value === "string" ? value.match(/^(\d{4})-(\d{2})-(\d{2})$/) : null;
  const date = dateOnlyMatch
    ? new Date(Number(dateOnlyMatch[1]), Number(dateOnlyMatch[2]) - 1, Number(dateOnlyMatch[3]))
    : new Date(value);

  if (Number.isNaN(date.getTime())) {
    return String(value);
  }

  return date.toLocaleString(options?.locale, options?.format);
};

export const formatIndianDateTime = (value) =>
  formatDateTime(value, {
    locale: "en-IN",
    format: {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    },
  });

export const formatIndianDate = (value) =>
  formatDateTime(value, {
    locale: "en-IN",
    format: {
      day: "2-digit",
      month: "short",
      year: "numeric",
    },
  });

export const formatTimeValue = (value) => {
  if (!value) {
    return "-";
  }

  return String(value).slice(0, 5);
};

export const formatTimeRange = (startRange, endRange) => {
  if (!startRange && !endRange) {
    return "-";
  }

  return `${formatTimeValue(startRange)} - ${formatTimeValue(endRange)}`;
};

export const formatValue = (value) => {
  if (value === null || value === undefined || value === "") {
    return "-";
  }

  return String(value);
};

export const joinValues = (values) => {
  const filteredValues = values.filter(
    (value) => value !== null && value !== undefined && String(value).trim() !== ""
  );

  return filteredValues.length > 0 ? filteredValues.join(", ") : "-";
};

export const getAddressSummary = (address = {}) =>
  joinValues([
    [address.receiverFirstName, address.receiverLastName].filter(Boolean).join(" "),
    address.receiverPhone,
    address.receiverEmail,
    address.apartment,
    address.city,
    address.state,
    address.zip,
    address.country,
    address.countryCode,
  ]);
